// Load helper
import isMobile from './helper/isMobile'

/**
 * Initialize PreachersPlanTable.
 */
jQuery(document).ready(function () {
  // init if page contains the block
  if (jQuery('.wpgt-block-preachers-plan')[0]) {
    let table = new PreachersPlanTable()
    table.init()
  }
})

function PreachersPlanTable() {
  /**
   * Number of visible columns
   *
   * @type Integer
   */
  this.numVisibleCols = 2

  /**
   * DateString of active column (YYYY-MM-DD)
   *
   * @type String
   */
  this.activeDateString = ''

  /**
   * jQuery element of the table
   *
   * @type {*}
   */
  this.tableElem = {}

  /**
   * jQuery element of the prev button
   *
   * @type {*}
   */
  this.prevBtnElem = {}

  /**
   * jQuery element of the next button
   *
   * @type {*}
   */
  this.nextBtnElem = {}

  /**
   * List of all saved dates
   *
   * @type String[]
   */
  this.dates = []

  /**
   * Rows of each location. {'Aarau': ['09:30', ...]}
   *
   * @type {*}
   */
  this.rows = {}

  /**
   * Urls of all locations
   *
   * @type {*}
   */
  this.urls = {}

  /**
   * Label names
   *
   * @type {*}
   */
  this.labels = {}

  /**
   * Fetches the data of the first few sabbaths for the table.
   */
  this.fetchInitalData = async function () {
    return this.fetchData(true, null)
  }

  /**
   * Truncates a date to a date without hours.
   */
  this.truncateDate = function (aDate) {
    aDate.setHours(0, 0, 0, 0)
    return aDate
  }

  /**
   * Fetches the data from the API.
   * There are 3 methods to specify a request:
   * 1) initial = true | gets the initial data (first 2 months starting from today)
   * 2) startDate = '2022-10-23' | gets the data for the following month
   * 3) specMonth = '9', specYear = '2022' | gets the data for the specified month and year
   * Saves the data in {this.dates} and {this.rows}.
   */
  this.fetchData = function (
    initial = false,
    startDate,
    specMonth = null,
    specYear = null
  ) {
    // build dateString for request
    let requestParameter = null
    if (initial) {
      requestParameter = 2 // values of the next 2 months
    } else {
      let selectedStartDate = startDate ? new Date(startDate) : new Date()
      let nextMonth = specMonth
        ? specMonth
        : selectedStartDate.getMonth() === 11
        ? 1
        : selectedStartDate.getMonth() + 2
      let nextYear = specYear
        ? specYear
        : nextMonth === 1
        ? selectedStartDate.getFullYear() + 1
        : selectedStartDate.getFullYear()
      requestParameter = nextYear + '-' + this.prependZeroMonth(nextMonth)
      // searchString to check if data is already fetched earlier
      if (this.dates.filter((date) => date.includes(requestParameter)).length > 0) {
        // if we have already saved the data
        return
      }
    }

    let today = this.truncateDate(new Date())
    return fetch(`https://termine.adventisten.ch/pp/${requestParameter}.json`)
      .then((response) => response.json())
      .then((data) => {
        //initialize rows and location urls
        data.entries[0].locations.forEach((location) => {
          this.rows[location.name] = this.rows[location.name] || []
          this.urls[location.name] = this.urls[location.name] || location.url
        })

        // fill rows and dates
        data.entries.forEach((entry) => {
          // append all dates, except the past dates
          this.dates = this.dates
            .concat(entry.dates)
            .filter((date) => this.truncateDate(new Date(date)) >= today)
          entry.locations.forEach((location) => {
            location.services.forEach((service) => {
              let serviceDate = new Date(service.date)
              // skip dates from the past
              if (serviceDate >= today) {
                this.rows[location.name].push({
                  value: service.serviceStart,
                  index: service.date,
                })
                this.rows[location.name].push({
                  value: service.pastor,
                  index: service.date,
                  url: service.url,
                  labels: service.labels,
                })
              }
            })
          })
        })
      })
  }

  /**
   * Builds the table from the initialized field values.
   */
  this.buildTable = function () {
    // prepare heads and rows
    let tHeads = ['Gemeinde/Gruppe']
      .concat(this.dates.map((date) => ['', 'Sabbat ' + this.getGermanDateString(date)]))
      .flat()
    let tRows = Object.entries(this.rows).map((item) => item.flat())

    // build table
    let html = `<div class="preachers-plan-table-wrapper"><table>
    <tr>
      ${tHeads
        .map(
          (heading, idx) =>
            `<th class="${idx % 2 === 1 ? 'time-col' : ''}" data-date="${
              idx > 0 ? this.dates[Math.floor((idx - 1) / 2)] : ''
            }">${heading}</th>`
        )
        .join('')}
    </tr>${tRows
      .map(
        (row) =>
          `<tr>${row
            .map(
              (rowElem, idx) =>
                `<td class="${
                  idx === 0 && !this.urls[rowElem] ? 'nolink' : ''
                }" data-date="${idx > 0 ? this.dates[Math.floor((idx - 1) / 2)] : ''}">${
                  idx > 0
                    ? this.renderCell(rowElem.url, rowElem.value, rowElem.labels)
                    : this.renderLocationCell(rowElem)
                }</td>`
            )
            .join('')}</tr>`
      )
      .join('')}</table></div>`

    this.tableElem.find('.preachers-plan-table-wrapper').replaceWith(html)
    this.registerLocationUrlCallback()
  }

  /**
   * Returns the html string of a location cell.
   */
  this.renderLocationCell = function (location) {
    return this.urls[location]?.length > 0
      ? `<a href="${this.urls[location]}" target="_blank">${location}</a>`
      : location
  }

  /**
   * Returns the html string of a cell.
   */
  this.renderCell = function (url, content, labels) {
    labels = labels?.length > 0 ? labels : []
    let labelHtml = labels
      .map(
        (label) =>
          `<span title="${this.labels[label]}" class="${'pp-icon icon-' + label}"></span>`
      )
      .join('')
    let contentHtml = (content ?? '') + labelHtml
    return url ? `<a href="${url}" target="_blank">${contentHtml}</a>` : contentHtml
  }

  /**
   * Fetch label names.
   */
  this.fetchLabels = async function () {
    return fetch('https://termine.adventisten.ch/api/master-data/labels')
      .then((response) => response.json())
      .then((labels) => labels.map((label) => (this.labels[label.key] = label.name)))
  }

  /**
   * Returns the list of active columns.
   */
  this.getActiveCols = function () {
    let startIdx = this.dates.indexOf(this.activeDateString)
    let stopIdx = startIdx + this.numVisibleCols
    return this.dates.slice(startIdx, stopIdx).concat([''])
  }

  /**
   * Toggles the visibility of all cells depending on which columns are active at the moment.
   */
  this.toggleVisibleCols = function () {
    let activeCols = this.getActiveCols()
    this.tableElem.find('td, th').each((idx, elem) => {
      let cellElem = jQuery(elem)
      if (!activeCols.includes(cellElem.attr('data-date'))) {
        cellElem.addClass('inactive-cell')
      } else {
        cellElem.removeClass('inactive-cell')
      }
    })
  }

  /**
   * Callback function for the prev button.
   * Updates the `activeDateString` and toggles visibility.
   */
  this.prevCallback = async function () {
    let curIdx = this.dates.indexOf(this.activeDateString)
    // if we would go to the past
    if (curIdx - this.numVisibleCols <= 0) {
      this.activeDateString = this.dates[0]
      this.prevBtnElem.addClass('inactive-btn')
    } else {
      // check if prev date is continuous
      let curDate = new Date(this.activeDateString)
      curDate.setDate(curDate.getDate() - this.numVisibleCols * 7) // expected date
      const curDateString = curDate.toISOString().split('T')[0]
      if (this.dates[curIdx - this.numVisibleCols].trim() !== curDateString.trim()) {
        // if not continuous, we need to fetch the prev month
        await this.fetchAdditionalData(
          null,
          curDate.getMonth() + 1,
          curDate.getFullYear()
        )
        this.sortData()
        this.buildTable()
        this.activeDateString = curDate.toLocaleDateString('en-CA')
      } else {
        this.activeDateString = this.dates[curIdx - this.numVisibleCols]
      }
    }

    this.nextBtnElem.removeClass('inactive-btn')
    this.toggleVisibleCols()
    this.toggleMonthSelector()
  }

  /**
   * Callback function for the next button.
   * Updates the `activeDateString` and toggles visibility.
   * Fetches additional data in case its needed.
   */
  this.nextCallback = async function () {
    let curIdx = this.dates.indexOf(this.activeDateString)
    // if we ran out of dates
    if (curIdx + this.numVisibleCols + this.numVisibleCols >= this.dates.length) {
      let nextSabbath = new Date(this.dates[this.dates.length - 1])
      nextSabbath.setDate(nextSabbath.getDate() + this.numVisibleCols * 7)
      // Hard limit at 1 year
      if (this.getFirstMonthNumber() === nextSabbath.getMonth()) {
        this.activeDateString = this.dates[this.dates.length - 1]
        this.nextBtnElem.addClass('inactive-btn')
        this.toggleVisibleCols()
        return
      }

      await this.fetchAdditionalData(this.dates[this.dates.length - 1])
      this.buildTable()
    }

    this.activeDateString = this.dates[curIdx + this.numVisibleCols]
    this.toggleVisibleCols()
    this.prevBtnElem.removeClass('inactive-btn')
    this.toggleMonthSelector()
  }

  /**
   * Fetches additional dates, triggered by the prev or next button or the month selector.
   */
  this.fetchAdditionalData = async function (
    startDate,
    specMonth = null,
    specYear = null
  ) {
    return this.fetchData(false, startDate, specMonth, specYear)
  }

  /**
   * Toggles the month selector when navigating with the prev and next buttons.
   */
  this.toggleMonthSelector = function () {
    let selectElem = jQuery('.preachers-plan-months-select select')
    let curVal = selectElem.val()
    let activeMonth = new Date(this.activeDateString).getMonth() + 1
    if (parseInt(curVal) !== activeMonth) {
      selectElem.val(activeMonth).change({})
    }
  }

  /**
   * Jumps to the selected month.
   */
  this.monthSelectorCallback = async function (event) {
    let today = new Date()
    let specYear =
      event.target.value >= this.getFirstMonthNumber() + 1
        ? today.getFullYear()
        : today.getFullYear() + 1
    await this.fetchAdditionalData(null, event.target.value, specYear)
    this.sortData()

    // set active date
    let matches = this.dates.filter((date) =>
      date.includes(specYear + '-' + this.prependZeroMonth(event.target.value))
    )
    this.activeDateString = matches[0]

    // rebuild table
    this.buildTable()
    this.toggleVisibleCols()

    // set btn opacity
    this.nextBtnElem.removeClass('inactive-btn')
    if (this.activeDateString.trim() === this.dates[0].trim()) {
      this.prevBtnElem.addClass('inactive-btn')
    } else {
      this.prevBtnElem.removeClass('inactive-btn')
    }
  }

  /**
   * Sorts the rows and dates data.
   */
  this.sortData = function () {
    this.dates.sort()
    Object.entries(this.rows).map((row) => {
      row[1].sort((a, b) => {
        if (a.index < b.index) {
          return -1
        }
        if (a.index > b.index) {
          return 1
        }
        if (a.value?.length === 0) {
          return 1
        }
        if (b.value?.length === 0) {
          return -1
        }
        if (a.value < b.value) {
          return -1
        }
        return 1
      })
    })
  }

  /**
   * Prepends a zero to single digit month numbers.
   */
  this.prependZeroMonth = function (numMonthString) {
    return numMonthString.length < 2 ? '0' + numMonthString : numMonthString
  }

  /**
   * Returns the number of the first month, -1 if no first month exists.
   */
  this.getFirstMonthNumber = function () {
    if (this.dates.length === 0) {
      return -1
    }
    return new Date(this.dates[0]).getMonth()
  }

  /**
   * Returns the german date String: DD.MM.YYYY
   */
  this.getGermanDateString = function (dateString) {
    let date = new Date(dateString)
    return date.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    })
  }

  /**
   * Makes the whole location cell clickable if url provided.
   */
  this.registerLocationUrlCallback = function () {
    jQuery('tr td').click((event) => {
      const url =
        event.target.tagName.toLowerCase() === 'a'
          ? event.target.href
          : jQuery(event.target).find('a').attr('href')
      if (url) {
        window.open(jQuery(event.target).find('a').attr('href'), '_blank')
      }
      return false
    })
  }

  /**
   * Initializes the Preachers Plan table.
   */
  this.init = async function () {
    // set initial field values
    this.numVisibleCols = isMobile() ? 1 : 2
    this.tableElem = jQuery('.wpgt-block-preachers-plan')
    this.nextBtnElem = jQuery('.next-btn')
    this.prevBtnElem = jQuery('.prev-btn')
    this.prevBtnElem.addClass('inactive-btn')

    // fetch data and build initial table
    await this.fetchInitalData()
    await this.fetchLabels()
    this.activeDateString = this.dates[0]
    this.buildTable()
    this.toggleVisibleCols()

    // register callbacks
    this.tableElem.find('.next-btn').click(() => this.nextCallback())
    this.tableElem.find('.prev-btn').click(() => this.prevCallback())
    this.tableElem
      .find('.preachers-plan-months-select')
      .change((event) => this.monthSelectorCallback(event))
    this.registerLocationUrlCallback()
  }
}
